import { render, staticRenderFns } from "./PatientWeightInput.vue?vue&type=template&id=2b64ebc3&scoped=true&"
import script from "./PatientWeightInput.vue?vue&type=script&lang=js&"
export * from "./PatientWeightInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientWeightInput.vue?vue&type=style&index=0&id=2b64ebc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64ebc3",
  null
  
)

export default component.exports